import React from 'react';
import PropTypes from 'prop-types';
import { orange } from '@mui/material/colors';

import { theme } from 'theme';
import Boxplot from 'ui/Boxplot/Boxplot';

const style = {
  fillOpacity: 1,
};
const medianStyle = {
  stroke: 'white',
  strokeDasharray: 2,
};
const boxStyle = {
  stroke: theme.palette.primary.main,
  fill: theme.palette.primary.main,
};
const tickStyle = {
  stroke: theme.palette.primary.main,
};
const whiskerStyle = {
  stroke: theme.palette.primary.main,
};
const outlierStyle = {
  stroke: orange[700],
  fill: orange[700],
};

const BoxPlot = ({ stats, min, max, width, height }) => {
  return (
    <Boxplot
      orientation="horizontal"
      width={width}
      height={height}
      min={min}
      max={max}
      medianStrokeWidth={1}
      outlierRadius={5}
      style={style}
      medianStyle={medianStyle}
      boxStyle={boxStyle}
      tickStyle={tickStyle}
      whiskerStyle={whiskerStyle}
      outlierStyle={outlierStyle}
      stats={{
        ...stats,
        outliers: Array.isArray(stats.outliers) ? stats.outliers : [stats.outliers],
      }}
    />
  );
};

BoxPlot.defaultProps = {
  width: 300,
  height: 25,
};

BoxPlot.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stats: PropTypes.shape({
    whiskerLow: PropTypes.number,
    whiskerHigh: PropTypes.number,
    outliers: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
    quartile1: PropTypes.number,
    quartile2: PropTypes.number,
    quartile3: PropTypes.number,
  }).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default BoxPlot;
